import {TimelineI18n} from '@/locales/base.message.locales';

export const timeline: TimelineI18n = {
  messages: {
    interaction_deleted: 'Interaction deleted',
    interaction_deleted_error: 'Sorry some error occurred when try to delete your interaction',
    interaction_registered: 'Interaction registered',
    interaction_registered_error: 'Sorry some error occurred when try to register your interaction',
    reply_registered: 'reply registered',
    reply_registered_error: 'Sorry some error occurred when try to register your reply',
    end_date: 'End date',
    init_date: 'Start date ',
    replies_received: 'Replies received',
    my_interactions: 'My activity',
    you_are_here: 'You are here'
  },
  labels: {
    interaction: 'Add Interaction',
    see_interactions: 'See Interactions',
    add_reply: 'Add reply',
    view_reply: 'View replies',
    edit_reply: 'Edit reply',
    remove_reply: 'Remove reply',
    load_replies: 'Load replies',
    title: 'Title',
    description: 'Description',
    already_done: 'You have done this',
    you_are_here: 'You\'re here'
  }
};
